import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import SectionHeading from '@/components/base/SectionHeading';

export default function HotRanking() {
  const hot = [...articles].filter((a) => a.hotRank).sort((a, b) => (a.hotRank as number) - (b.hotRank as number)).slice(0, 6);

  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <SectionHeading
          eyebrow="TODAY RANKING"
          title="今日热榜"
          desc="按阅读热度与线索密度排序，榜单每个整点刷新。"
          action={
            <Link to="/#categories" className="inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-800 cursor-pointer whitespace-nowrap">
              查看全部栏目
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
        <div className="grid lg:grid-cols-12 gap-6">
          <ol className="lg:col-span-8 flex flex-col gap-3">
            {hot.map((a, i) => (
              <li key={a.id}>
                <Link
                  to={`/article/${a.id}`}
                  className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors cursor-pointer"
                >
                  <span
                    className={`shrink-0 w-9 h-9 rounded-md flex items-center justify-center font-heading font-bold ${
                      i < 3 ? 'bg-accent-600 text-background-50' : 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    {i + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 line-clamp-1 group-hover:text-accent-700 transition-colors">
                      {a.title}
                    </h3>
                    <div className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                      <span className="px-2 py-0.5 rounded bg-secondary-100 text-secondary-800">{a.categoryName}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {a.views}
                      </span>
                      <span className="hidden sm:flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {a.date}
                      </span>
                    </div>
                  </div>
                  <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-accent-600 transition-colors"></i>
                </Link>
              </li>
            ))}
          </ol>

          <aside className="lg:col-span-4">
            <div className="rounded-lg border border-primary-200 bg-primary-50 p-6 h-full flex flex-col">
              <span className="w-11 h-11 rounded-md bg-primary-600 text-background-50 flex items-center justify-center mb-4">
                <i className="ri-megaphone-line text-xl"></i>
              </span>
              <h3 className="font-heading font-bold text-lg text-foreground-950">你手里，可能就有下一条独家</h3>
              <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">
                不论是内部消息、现场见闻，还是看不下去的一件事，都可以匿名投稿。我们会交叉核实后整理发布，并对线索来源保密。
              </p>
              <ul className="mt-5 space-y-2.5 text-sm text-foreground-700">
                <li className="flex items-center gap-2">
                  <i className="ri-shield-check-line text-primary-600"></i>
                  支持匿名提交
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-git-branch-line text-primary-600"></i>
                  多信源交叉核实
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-file-list-3-line text-primary-600"></i>
                  结果以时间线呈现
                </li>
              </ul>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center justify-center gap-2 h-11 px-5 rounded-md bg-accent-600 text-background-50 text-sm font-medium hover:bg-accent-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-send-plane-line"></i>
                我要爆料
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}